import React, { useState, useEffect, useRef } from 'react';
import { FaFile, FaEdit } from "react-icons/fa";
import { CiFileOn } from "react-icons/ci";
import './handbook.css';
import JoditEditor from 'jodit-react';
import { Form, Button, Alert } from 'react-bootstrap';
import axios from '../../Authservices/axiosInstance';
const Handbook = () => {
    const [handbookReport, setHandbookReport] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const editor = useRef(null);

    const config = {
        readonly: false,
        height: 'auto', // let height be auto
        minHeight: 200,
        maxHeight: 'none',
        style: {
            overflow: 'hidden'
        },
        iframe: false,
        showCharsCounter: false,
        showWordsCounter: false,
        showXPathInStatusbar: false,
        toolbarSticky: false,
    };

    useEffect(() => {
        const fetchHandbook = async () => {
            try {
                const response = await axios.get('https://backend.ems.uk.hiradentallab.com/api/handbook/');
                setHandbookReport(response.data.summary);
            } catch (err) {
                setError('Failed to fetch handbook data.');
                setTimeout(() => setError(''), 3000);
            }
        };
        fetchHandbook();
    }, []);

    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.put('https://backend.ems.uk.hiradentallab.com/api/handbook/update', { summary: handbookReport });
            setSuccess('Handbook updated successfully!');
            setError('');
            setHandbookReport(response.data.handbook.summary);
            setTimeout(() => setSuccess(''), 3000);
        } catch (err) {
            setError('Failed to update handbook. Please try again.');
            setSuccess('');
            setTimeout(() => setError(''), 3000);
        }
    };

    return (
        <div className='container-fluid'>
            <div className="header-style">
                <h1 style={{ color: '#0353a4', marginTop: '60px', textAlign: 'left', fontSize: '2rem' }}>
                    <FaFile /> Hand Book
                </h1>
                <hr style={{ marginBottom: '10px' }} />
                <h1 style={{ color: '#0353a4', textAlign: 'left', fontSize: '2rem' }}>
                    <CiFileOn /> Hira Dental Lab Handbook
                </h1>
                <hr style={{ marginBottom: '10px' }} />
            </div>
            <div className='handbook-content'>
                {error && <Alert variant='danger'>{error}</Alert>}
                {success && <Alert variant='success'>{success}</Alert>}
                <Form onSubmit={handleUpdate}>
                    <div className="mb-3">
                        <Form.Label htmlFor="reportEditor" className="form-label">HandBook:</Form.Label>
                        <div className="editor-wrapper">
                            <JoditEditor
                                ref={editor}
                                value={handbookReport}
                                config={config}
                                tabIndex={1}
                                onBlur={(newContent) => setHandbookReport(newContent)}
                            />
                        </div>
                    </div>
                    <div className="d-flex justify-content-end mt-3">
                        <Button type='submit' variant='primary'>
                            <FaEdit /> Update Handbook
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    );
};

export default Handbook;